export default {"src":"/_next/static/media/slope.2f329981.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};